import { createBrowserHistory } from 'history'
// import { useHistory } from 'react-router-dom-v5-compat';

const history = createBrowserHistory()
// const history = useHistory()
export default history
